export const ERROR_CODE = {
  SUCCESS: 0,
  INSUFFICIENT_NET_VALUE: 50008,
  SUB_ACCOUNT_NOT_ALLOW: 50006,
};
export const PRIZE_COIN_NAME = 'USD';
